import React from 'react';

const WAVING_SVG_URL = 'https://db.pokketcoach.com/storage/v1/object/public/pokket-icons//pokket_waving.svg';

/**
 * PokketWaving component displays the static waving Pokket image
 * Used for the first-time message tutorial animation
 * 
 * @param {string} className - Additional CSS classes to apply
 */
const PokketWaving = ({ className }) => {
  return (
    <div className={`pokket-waving-container ${className || ''}`}>
      <img 
        src={WAVING_SVG_URL} 
        alt="Pokket waving hello" 
        className="pokket-waving-image"
      />
    </div>
  );
};

export default PokketWaving; 